import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/typography';
import { usePartnersQuery } from './usePartnersQuery';
import Loader from '@/components/Loader';
export default function PartnersList() {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["partners"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    data: t1,
    isLoading,
    isError
  } = usePartnersQuery(process.env.NEXT_PUBLIC_LANGUAGE);
  let t2;
  if ($[1] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const partners = t2;
  if (isLoading) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Loader />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (isError || partners.length === 0) {
    return null;
  }
  let t3;
  if ($[4] !== partners || $[5] !== t) {
    let t4;
    if ($[7] !== t) {
      t4 = (partner, index) => <div key={index}><Text variant="p1" weight="semibold" as="p">{partner.name}</Text><Text variant="p3" as="p">{t("partners:table.cin")}: {partner.cin}</Text></div>;
      $[7] = t;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = partners.map(t4);
    $[4] = partners;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}